import { AxiosRequestConfig }   from "axios"
import { RunContextApp }        from "framework/RCApp"
import { ApiResponse }          from "types"
import { GetEventsAPI, 
         CreateEventAPI, 
         EditEventAPI,
         DeleteEventAPI
       }                        from "types/eventManagement/EventManagementInterface"

export const EventManagementAPI = {

  fetchEvents : async (rc : RunContextApp, params : GetEventsAPI.params) 
      : Promise<ApiResponse<GetEventsAPI.retval>> => {
    
    const request : AxiosRequestConfig = {
      params : params
    } 
    const resp = await rc.apiClient.get<GetEventsAPI.retval>(GetEventsAPI.epiEndpoint(), request)
    return resp
  },

  createEvent : async (rc : RunContextApp, params : CreateEventAPI.params , isInstantaneousEV : boolean = false) 
      : Promise<ApiResponse<CreateEventAPI.retval>> => {

    const resp = await rc.apiClient.post<CreateEventAPI.retval>(CreateEventAPI.epiEndpoint(isInstantaneousEV), params)
    return resp
  },

  editEvent : async (rc : RunContextApp, params : EditEventAPI.params) 
      : Promise<ApiResponse<EditEventAPI.retval>> => {

    const resp = await rc.apiClient.put<EditEventAPI.retval>(EditEventAPI.epiEndpoint(), params)
    return resp
  },

  deleteEvent : async (rc : RunContextApp, params : DeleteEventAPI.params) 
      : Promise<ApiResponse<DeleteEventAPI.retval>> => {

    const request : AxiosRequestConfig = {
      data : params
    } 
    const resp = await rc.apiClient.delete<DeleteEventAPI.retval>(DeleteEventAPI.epiEndpoint(), request)
    return resp
  }

}